import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "space-y-6" }
const _hoisted_2 = { class: "flex gap-y-6 flex-row flex-wrap" }
const _hoisted_3 = { class: "flex gap-y-6 flex-row flex-wrap" }
const _hoisted_4 = { class: "flex gap-y-6 flex-row flex-wrap" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_6 = { class: "space-y-6" }
const _hoisted_7 = { class: "flex gap-y-6 flex-row flex-wrap" }
const _hoisted_8 = { class: "flex gap-y-6 flex-row flex-wrap" }
const _hoisted_9 = { class: "flex flex-col gap-2" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "font-semibold flex flex-row items-center" }, " Digunakan untuk ", -1)
const _hoisted_11 = { class: "grid grid-cols-2 gap-2 w-4/12" }
const _hoisted_12 = { class: "text-black-lp-300 text-12px xxl:text-14px w-4/5" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, "Status Terkini", -1)
const _hoisted_14 = { class: "my-1 font-normal" }
const _hoisted_15 = { class: "flex" }
const _hoisted_16 = { class: "text-black-lp-300 text-12px xxl:text-14px w-4/5" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, "Tanggal Dibuat", -1)
const _hoisted_18 = { class: "my-1 font-normal" }
const _hoisted_19 = { class: "text-gray-lp-500" }
const _hoisted_20 = { class: "text-black-lp-300 text-12px xxl:text-14px w-4/5" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, "Tanggal Diubah", -1)
const _hoisted_22 = { class: "my-1 font-normal" }
const _hoisted_23 = { class: "text-gray-lp-500" }
const _hoisted_24 = { class: "inline-flex flex-col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_CheckboxV2 = _resolveComponent("CheckboxV2")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_button_outline = _resolveComponent("button-outline")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!

  return (_openBlock(), _createBlock(_component_DetailLayout, {
    scrollSidebar: "",
    customClass: "px-0",
    onBack: _ctx.goBack,
    title: _ctx.detailPromoConfiguration.promoConfigurationName,
    loading: _ctx.isLoading,
    error: !!_ctx.errorCause,
    errorType: _ctx.errorCause,
    onTryAgain: _ctx.fetchDetail
  }, {
    data: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_Title, { label: "Detail Promo" }),
        _createVNode(_component_DataWrapper, {
          label: "Promo ID",
          value: _ctx.detailPromoConfiguration.promoConfigurationId
        }, null, 8, ["value"]),
        _createVNode(_component_DataWrapper, {
          label: "Nama Promo",
          value: _ctx.detailPromoConfiguration.promoConfigurationName
        }, null, 8, ["value"]),
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_DataWrapper, {
            class: "w-6/12",
            label: "Kota Asal",
            value: 
              _ctx.detailPromoConfiguration.promoConfigurationOrigin === 'ALL'
                ? 'Semua'
                : _ctx.detailPromoConfiguration.promoConfigurationOrigin
            
          }, null, 8, ["value"]),
          _createVNode(_component_DataWrapper, {
            class: "w-6/12",
            label: "Kota Tujuan",
            value: 
              _ctx.detailPromoConfiguration.promoConfigurationDestination === 'ALL'
                ? 'Semua'
                : _ctx.detailPromoConfiguration.promoConfigurationDestination
            
          }, null, 8, ["value"])
        ]),
        _createVNode(_component_DataWrapper, {
          label: "Produk Pengiriman",
          value: _ctx.detailPromoConfiguration.promoConfigurationProductType
        }, null, 8, ["value"]),
        _createVNode(_component_DataWrapper, {
          label: "Berat Acuan",
          value: _ctx.detailPromoConfiguration.pdcPromoReferenceWeight
        }, null, 8, ["value"]),
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_DataWrapper, {
            class: "w-6/12",
            label: "Berat Minimal",
            value: 
              _ctx.detailPromoConfiguration.promoConfigurationMinimalGrossWeight +
                'Kg'
            
          }, null, 8, ["value"]),
          _createVNode(_component_DataWrapper, {
            class: "w-6/12",
            label: "Berat Maksimal",
            value: 
              _ctx.detailPromoConfiguration.promoConfigurationMaximalGrossWeight +
                'Kg'
            
          }, null, 8, ["value"])
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_DataWrapper, {
            class: "w-6/12",
            label: "Tanggal Mulai",
            value: 
              _ctx.formatDate(_ctx.detailPromoConfiguration.promoConfigurationStartDate)
            
          }, null, 8, ["value"]),
          _createVNode(_component_DataWrapper, {
            class: "w-6/12",
            label: "Tanggal Berakhir",
            value: 
              _ctx.formatDate(_ctx.detailPromoConfiguration.promoConfigurationEndDate)
            
          }, null, 8, ["value"])
        ]),
        _createVNode(_component_DataWrapper, {
          label: "Jenis Promo",
          value: _ctx.startCase(_ctx.detailPromoConfiguration.promoConfigurationType)
        }, null, 8, ["value"])
      ]),
      _hoisted_5,
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_Title, { label: "Aturan Diskon" }),
        _createVNode(_component_DataWrapper, {
          label: "Tipe Promo Diskon",
          value: 
            _ctx.firstCapitalize(
              _ctx.detailPromoConfiguration.promoConfigurationDiscountType
            )
          
        }, null, 8, ["value"]),
        _createVNode("div", _hoisted_7, [
          _createVNode(_component_DataWrapper, {
            class: "w-6/12",
            label: "Persentase Diskon",
            value: 
              _ctx.detailPromoConfiguration.promoConfigurationPromoDiscount + '%'
            
          }, null, 8, ["value"]),
          _createVNode(_component_DataWrapper, {
            class: "w-6/12",
            label: "Maksimum Diskon",
            value: 
              'IDR ' + _ctx.detailPromoConfiguration.promoConfigurationMaximalPromo
            
          }, null, 8, ["value"])
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode(_component_DataWrapper, {
            class: "w-6/12",
            label: "Kalkulasi Parameter",
            value: 
              _ctx.promoQuantifier(
                _ctx.detailPromoConfiguration.promoConfigurationParameterCalculation
              )
            
          }, null, 8, ["value"])
        ]),
        _createVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode(_component_CheckboxV2, {
            label: "Shipment :",
            textSize: 14,
            keyName: "CODDeliveryPartnerAdd",
            className: "p-field-checkbox-grey",
            labelWeight: "normal",
            value: _ctx.detailPromoConfiguration.promoConfigurationAppliedList.includes('shipment') ?  true : false
          }, null, 8, ["value"]),
          _createVNode("div", _hoisted_11, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.shipmentList, (shipment, index) => {
              return (_openBlock(), _createBlock("div", {
                key: index.toString(),
                class: "pl-10"
              }, [
                _createVNode(_component_CheckboxV2, {
                  label: shipment.keyName,
                  textSize: 14,
                  keyName: "CODDeliveryPartnerAdd",
                  className: "p-field-checkbox-grey",
                  labelWeight: "normal",
                  value: shipment.value,
                  disabled: shipment.disabled
                }, null, 8, ["label", "value", "disabled"])
              ]))
            }), 128))
          ])
        ]),
        _createVNode(_component_CheckboxV2, {
          label: "Retail",
          textSize: 14,
          class: "mt-4 pb-10",
          keyName: "CODDeliveryPartnerAdd",
          className: "p-field-checkbox-grey",
          labelWeight: "normal",
          value: _ctx.detailPromoConfiguration.promoConfigurationAppliedList.includes('retail') ?  true : false
        }, null, 8, ["value"])
      ])
    ]),
    "sub-data": _withCtx(() => [
      _createVNode("div", _hoisted_12, [
        _hoisted_13,
        _createVNode("div", _hoisted_14, [
          _createVNode("div", _hoisted_15, [
            _createVNode("div", {
              class: ["rounded-full px-2 text-12px xxl:text-14px font-medium", 
                _ctx.onChipStatus(_ctx.detailPromoConfiguration.promoConfigurationStatus)
                  ?.style
              ]
            }, _toDisplayString(_ctx.onChipStatus(_ctx.detailPromoConfiguration.promoConfigurationStatus)
                  ?.value), 3)
          ])
        ])
      ]),
      _createVNode("div", _hoisted_16, [
        _hoisted_17,
        _createVNode("div", _hoisted_18, _toDisplayString(_ctx.formatDate(_ctx.detailPromoConfiguration.promoConfigurationCreatedAt)), 1),
        _createVNode("div", _hoisted_19, _toDisplayString(_ctx.detailPromoConfiguration.promoConfigurationCreatedName), 1)
      ]),
      _createVNode("div", _hoisted_20, [
        _hoisted_21,
        _createVNode("div", _hoisted_22, _toDisplayString(_ctx.formatDate(_ctx.detailPromoConfiguration.promoConfigurationUpdatedAt)), 1),
        _createVNode("div", _hoisted_23, _toDisplayString(_ctx.detailPromoConfiguration.promoConfigurationUpdatedName), 1)
      ]),
      _createVNode("div", _hoisted_24, [
        (_ctx.isShowEditButton && _ctx.isEditAble)
          ? (_openBlock(), _createBlock(_component_button_fill, {
              key: 0,
              title: "Ubah Promo",
              onClick: _ctx.goToEdit,
              class: "px-4 mb-6"
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (_ctx.isShowDuplicateButton && _ctx.isDuplicateAble)
          ? (_openBlock(), _createBlock(_component_button_outline, {
              key: 1,
              title: "Duplicate",
              onClick: _cache[1] || (_cache[1] = () => {}),
              class: "px-4"
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["onBack", "title", "loading", "error", "errorType", "onTryAgain"]))
}